<template>
  <div>
    <h2 class="h2-title">Faça login em sua conta do Travessia!</h2>
    <div class="container">
      <t-input
        :placeholder="'Seu email'"
        :name="'login'"
        :classIcon="'fas fa-user'"
        v-model="loginForm.email"
        :verifiyError="$v.loginForm.email.$error"
        @blur="$v.loginForm.$touch()"
      />
      <div class="errors-form-messages" v-if="$v.loginForm.email.$error">
        <ul class="contactForm__messages">
          <li v-if="!$v.loginForm.email.required">* O campo email é obrigatório.</li>
          <li v-if="!$v.loginForm.email.emai">* Preencha um email válido.</li>
        </ul>
      </div>
    </div>
    <div class="container">
      <t-input
        :placeholder="'Sua senha'"
        :name="'password'"
        :classIcon="'fas fa-user'"
        :type="'password'"
        v-model="loginForm.password"
        :verifiyError="$v.loginForm.password.$error"
        @blur="$v.loginForm.$touch()"
      />
      <div class="errors-form-messages" v-if="$v.loginForm.password.$error">
        <ul class="contactForm__messages" v-if="$v.loginForm.password.$error">
          <li v-if="!$v.loginForm.password.required">* O campo senha é obrigatório.</li>
        </ul>
      </div>
    </div>
    <div class="container">
      <t-button class="button-width" @click="doLogin()">Entrar</t-button>
    </div>
    <div>
      <p class="text-center">
        ou
        <a href="#" class="links">Esqueci a senha</a>
      </p>
    </div>
  </div>
</template>

<script>
import TButton from '@/components/TButton.vue'
import TInput from '@/components/TInput.vue'
import notification from '@/support/mixins/notifications.mixin'
import { mapActions } from 'vuex'
// import { http } from '@/support/http/http'
import formErrors from '@/support/mixins/form-errors.mixin'
import { required, email } from 'vuelidate/lib/validators'
export default {
  name: 'LoginStudent',
  components: {
    TButton,
    TInput
  },
  mixins: [notification, formErrors],
  data: () => ({
    loginForm: {
      email: '',
      password: ''
    }
  }),
  methods: {
    ...mapActions('Login', ['login']),
    doLogin () {
      const fields = [this.$v.loginForm]
      this.verifyErrorsForm(fields)
        .then(() => {
          this.loading = true

          const email = this.loginForm.email
          const password = this.loginForm.password
          this.login({ email, password })
            .then(() => {
              this.loading = false
              this.$router.push({ name: 'Dashboard Módulos' })
            })
            .catch(err => {
              console.log(err)
              this.loading = false
              this.errorMsg(
                'Usuário',
                `${err.response.data.message}`,
                'topCenter'
              )
            })
        })
        .catch(() => {
          console.log('teste')
          this.errorMsg(
            'Usuário',
            'Não foi possivel realizar o login, verifique os erros no formulario',
            'topCenter'
          )
        })
    }
  },
  validations: {
    loginForm: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  }
}
</script>
<style scoped>
.login {
  margin-bottom: 4%;
}
</style>
